import { type CountryCode } from 'react-native-country-picker-modal'

export const ALLOWED_COUNTRY_CODES: CountryCode[] = [
  'US',
  'CN',
  'IN',
  'JP',
  'DE',
  'GB',
  'FR',
  'IT',
  'CA',
  'BR',
  'RU',
  'KR',
  'AU',
  'MX',
  'ID',
  'SA',
  'ZA',
  'TR',
  'AR',
  'ES',
  'BZ',
  'CR',
  'SV',
  'GT',
  'HN',
  'NI',
  'PA',
  'BO',
  'CL',
  'CO',
  'EC',
  'PY',
  'PE',
  'UY',
  'VE',
  'CU',
  'DO',
  'HT',
]

export const CALLING_CODE_BY_COUNTRY: Partial<Record<CountryCode, string>> = {
  US: '1',
  CN: '86',
  IN: '91',
  JP: '81',
  DE: '49',
  GB: '44',
  FR: '33',
  IT: '39',
  CA: '1',
  BR: '55',
  RU: '7',
  KR: '82',
  AU: '61',
  MX: '52',
  ID: '62',
  SA: '966',
  ZA: '27',
  TR: '90',
  AR: '54',
  ES: '34',
  BZ: '501',
  CR: '506',
  SV: '503',
  GT: '502',
  HN: '504',
  NI: '505',
  PA: '507',
  BO: '591',
  CL: '56',
  CO: '57',
  EC: '593',
  PY: '595',
  PE: '51',
  UY: '598',
  VE: '58',
  CU: '53',
  DO: '1',
  HT: '509',
}
